import { useEffect, useState } from 'react';

/** Returns `value` delayed by `delayMs`, resetting the timer on each change.
 * Used to throttle expensive reactions (e.g. map re-framing) to typing. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
